import { Grid, lighten } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { FONT_REG } from '../../constants/Styles';
import TnAvatar from '../tn-avatar/TnAvatar';
import TnTypography from '../tn-typography/TnTypography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    zIndex: 9000,
  },

  label: {
    fontSize: '16px',
    color: '#292929',
  },

  menuItem: {
    height: 48,
    paddingLeft: '18px',
    minWidth: 250,
    '&:hover': {
      backgroundColor: lighten(theme.palette.primary.main, 0.5),
    },
  },

  userNameContainer: {
    paddingTop: 8,
    paddingBottom: 8,
  },

  unclickable: {
    height: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default',
    },
  },

  nameContainer: {
    width: 'auto',
    marginLeft: 8,
  },

  avatarContainer: {
    margin: 0,
  },

  email: {
    height: '14px',
    color: '#C9C9C9',
    fontSize: '10px',
    fontWeight: 500,
    wordBreak: 'break-all',
  },

  menuItemLabel: {
    ...FONT_REG,
    fontSize: '10px',
    color: '#292929',
    '&:hover': {
      fontWeight: 'bold',
    },
  },

  paperRoot: {
    zIndex: '9000',
  },

  buttonBack: {
    backgroundColor: 'white !important',
  },

  dropDownButton: {
    '&:hover': {
      color: '#0074F2',
    },
  },

  menu: {
    // width: 143,
    zIndex: 1000000,
    boxShadow: '6px 3px 14px 6px rgba(0,0,0,0.08)',
  },

  menuHeader: {
    paddingLeft: '18px',
    height: '40px',
  },

  popper: {
    zIndex: 100000,
  },

  iconButtonRoot: {
    '&:hover': {
      backgroundColor: 'unset',
    },
  },

  menuitemRoot: {
    width: '100px',
  },

  menuListPadding: {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
});

class MenuDropDown extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div>
          <Popper
            open={this.props.open}
            anchorEl={this.props.event}
            placement={'bottom-end'}
            transition
            disablePortal
            // className={classes.popper}
            style={{ position: 'relative', zIndex: 100000000 }}
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} id="menu-list-grow">
                <Paper elevation={2} classes={{ root: classes.paperRoot }} className={classes.menu}>
                  <ClickAwayListener onClickAway={this.props.handleClose}>
                    <MenuList classes={{ padding: classes.menuListPadding }}>
                      {this.props.showUser && (
                        <MenuItem
                          className={classNames({
                            [classes.menuItem]: true,
                            [classes.unclickable]: true,
                          })}
                        >
                          <Grid className={classes.userNameContainer} container direction="row" justify="flex-start">
                            <TnAvatar
                              size="medium"
                              src={this.props.avatarUrl}
                              isCompletePath={true}
                              name={this.props.userName ?? ''}
                              className={classes.avatarContainer}
                            />
                            <Grid className={classes.nameContainer} container direction="column" justify="flex-start">
                              <Grid item>
                                <TnTypography bold variant="caption">
                                  {this.props.userName}
                                </TnTypography>
                              </Grid>
                              <Grid item>
                                <TnTypography variant="caption2">{this.props.role}</TnTypography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </MenuItem>
                      )}
                      {this.props.menuItems.map((element, index) => (
                        <MenuItem
                          key={element.label + index}
                          className={classes.menuItem}
                          onClick={(event) => {
                            element.onclick();
                            this.props.handleClose(event);
                          }}
                          data-testid={element.label}
                        >
                          <Grid container alignItems="center" direction="row" justify="flex-start">
                            <Grid item>
                              <TnTypography variant="overline">{element.label}</TnTypography>
                            </Grid>
                          </Grid>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MenuDropDown);
